---
title: "How Inventory Works"
slug: how-inventory-works
description: "Packages appear in your inventory automatically when scanned — there is no manual inventory entry step."
keywords:
  - inventory
  - scan
  - package
  - stock
  - GRAI
  - tracking
---

## Inventory is created by scanning

You do not need to manually enter packages into the system. Every time a package is scanned at an internal location — whether when sending or receiving — hey circle automatically records it in the inventory.

Scanning **is** the act of creating inventory. There is no separate "create inventory" step.

## How a package first appears

When you scan a package for the first time, hey circle reads the GRAI code (the barcode or QR code on the package). The package is then automatically:

1. Assigned to your location
2. Recorded in inventory as **"Available"**
3. Visible in the location's activity list

## What happens after a scan

| Scan type | What happens to inventory |
|---|---|
| Send (internal → internal) | Package changes location; stays in inventory |
| Send (internal → external) | Package leaves the internal stock; status becomes "In Transit" |
| Receive | Package returns to stock; status becomes "Available" |

## No manual inventory setup required

During initial setup, you do **not** need to perform any inventory step. As soon as your team begins sending and receiving packages, the inventory fills automatically.

If a package is not yet known in the system (GRAI never scanned before), you will be prompted to register it on the first scan. After that, it is permanently in the system.

## Viewing inventory

All roles — Admin, Manager, and Scanner — can open the full inventory list via **Settings → Inventory** in the top menu. The aggregated **Inventory Health** breakdown (package counts by status and defect rate per location) is part of the Analytics dashboard and is available to Admins and Managers only.

For a full permissions overview, see the [User Roles](/app/help?article=user-roles) article.

## Related Articles

- [Internal vs. External Locations](/app/help?article=internal-vs-external-locations)
- [Sending a Package](/app/help?article=sending-a-package)
- [Receiving a Package](/app/help?article=scanning-a-package)
- [Initial Setup](/app/help?article=initial-setup)
